<template>
  <div class="hidebackdrop">
    <b-modal ref="managegroups" class="managegroupsmodal" size="lg custom-overlay" :hide-footer="true" @shown="loadIntialData"  :no-close-on-backdrop="true" :no-fade="true">
      <div slot="modal-header" class="w-100">
        <p class="float-left modal-title">Manage Groups</p>
        <b-btn size="lg" class="float-right" variant="flat" @click="closeModal">
          <close-icon class="icon-default close modalclose"></close-icon>
        </b-btn>
      </div>
      <div class="col-md-10 mx-auto h-100">
        <div class="custom-tab">
          <div class="custom-tab-header">
            Create, Rename, Edit or Delete groups
          </div>
          <div class="custom-tab-body hasfooter">
            <div class="custom-tab-body-cont">
              <b-row class="site-selector-container p-4">
                <b-col cols="3">
                  <div class="selector-title p-2">
                    Groups
                  </div>
                  <div class="groups-wrapper px-2">
                    <ul class="groups-list">
                      <li class="" v-bind:class="{active:currentSelectedGroupID===group.groupID,editmode:group.edit,deletemode:group.showDelete}" v-for="(group,index) in groups" :key="group.groupID" @click="selectGroup(group)">
                        <a class="group-name" v-if="!group.edit">{{group.name}}</a>
                        <input type="text" class="edit-input" :ref="group.groupID" v-model="group.name" v-show="group.edit" @keyup.enter="saveEdit(group,index)" @blur="saveEdit(group,index)">
                        <span class="action-icon-cont" v-if="!group.showDelete && !group.edit">
                          <a @click="toggleEdit(group,index) " v-b-tooltip.hover.top.window title="Rename">
                            <write-icon class="icon-default write-icon"></write-icon>
                          </a>
                          <a @click="deleteGroup(group,index) " v-b-tooltip.hover.top.window title="Delete">
                            <delete-icon class="icon-default delete-icon"></delete-icon>
                          </a>

                        </span>
                        <span>
                          <a @click="saveEdit(group,index)" v-if="group.edit">
                            <tick-icon class="icon-default tick"></tick-icon>
                          </a>
                        </span>
                        <span v-if="group.showDelete" class="delete-confirmer">Sure?
                          <a @click="confirmDelete(group,index)" class="a-btns">Yes</a>
                          <a @click="cancelDelete(group,index)" class="a-btns">No</a>
                        </span>
                      </li>
                    </ul>
                  </div>
                </b-col>
                <b-col>
                  <div class="selector-title p-2 ">Select:
                    <a @click="selectAll() ">All</a>
                    <a @click="selectInvert() ">Invert</a>
                    <a @click="selectNone() ">None</a>
                  </div>
                  <div class="sites-wrapper px-2 ">
                    <b-form-group>
                      <b-form-checkbox-group id="checkboxes2 " name="flavour2 " v-model="selectedSiteIds">
                        <b-form-checkbox class="col-md-3 site-name" v-for="(site) in sites " :key="site.siteID " :value="site.siteID ">{{site.name}}</b-form-checkbox>
                      </b-form-checkbox-group>
                    </b-form-group>
                  </div>
                </b-col>
              </b-row>
            </div>
            <div class="custom-tab-body-footer ">
              <div class="row ">
                <div class="text-left col-md-6 ">
                  <b-form inline v-if="showCreateForm" @submit="createGroup()">
                    <b-input class="mb-2 mr-sm-2 mb-sm-0 " ref="groupnameinp" v-model="newGroupName" id="inlineFormInputName2 " placeholder="New group name" />
                    <b-button variant="outline-secondary " @click="createGroup() ">Create group</b-button>
                    <div v-if="groupNameUniqueError">
                      group name should be unique
                    </div>
                  </b-form>

                  <b-button v-if="!showCreateForm " type="button " variant="outline-secondary " @click="showCreateGroup">Create a New Group</b-button>
                </div>
                <div class="text-right col-md-6 ">
                  <b-button type="button " variant="primary " @click="saveChanges">Save Changes</b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import Vue from "vue";
import WriteIcon from "../../assets/write.svg";
import DeleteIcon from "../../assets/delete.svg";
import CloseIcon from "../../assets/close.svg";
import TickIcon from "../../assets/tick.svg";
import FormAlert from "../Common/FormAlert";
export default {
  name: "ManageGroups",
  components: {
    WriteIcon,
    DeleteIcon,
    CloseIcon,
    TickIcon,
    FormAlert
  },
  data() {
    return {
      groups: [],
      searchText: "",
      showCreateForm: false,
      newGroupName: "",
      newGroupCounter: 0,
      selectedSiteIds: [],
      selectedGroups: [],
      currentSelectedGroupID: "",
      tempGroupChangesBuffer: {},
      newGroupBuffer: {},
      deleteGroupBuffer: {},
      groupNameUniqueError: false,
      groupNameChangeBuffer: {}
    };
  },
  computed: {
    sites() {
      let sites = _.cloneDeep(this.$store.getters.getSites);
      return _.filter(sites, site => {
        return (
          site.name.toLowerCase().indexOf(this.searchText.toLowerCase()) > -1
        );
      });
    }
  },
  watch: {
    selectedSiteIds(updatedValue) {
      this.tempGroupChangesBuffer[this.currentSelectedGroupID] = updatedValue;
    }
  },
  methods: {
    loadIntialData() {
      this.groups = _.cloneDeep(this.$store.getters.getGroups);
      if (this.groups.length > 0) {
        this.currentSelectedGroupID = this.groups[0].groupID;
        this.selectGroup(this.groups[0]);
      }
    },
    selectAll() {
      this.selectedSiteIds = _.map(this.sites, site => {
        return site.siteID;
      });
    },
    selectInvert() {
      let tempArray = [];
      _.each(this.sites, site => {
        if (this.selectedSiteIds.indexOf(site.siteID) === -1) {
          tempArray.push(site.siteID);
        }
      });
      this.selectedSiteIds = tempArray;
    },
    selectNone() {
      this.selectedSiteIds = [];
    },
    selectGroup(group) {
      this.selectedSiteIds = [];
      this.currentSelectedGroupID = group.groupID;
      // if (this.tempGroupChangesBuffer[group.groupID]) {
      //   return;
      // }
      _.each(this.sites, site => {
        if (site.groupIDs) {
          let index = site.groupIDs.indexOf(group.groupID);
          if (index > -1) {
            this.selectedSiteIds.push(site.siteID);
          }
        }
      });
    },
    showCreateGroup() {
      this.showCreateForm = true;
      setTimeout(() => {
        this.$refs.groupnameinp.focus();
      }, 100);
    },
    createGroup() {
      let isAlreadyHaveGroup = _.find(this.groups, { name: this.newGroupName });
      if (isAlreadyHaveGroup) {
        console.log("already having same name");
        this.groupNameUniqueError = true;
        return;
      }

      let tempGroupID = `new-${this.newGroupCounter}`;
      this.groups.push({
        name: this.newGroupName,
        groupID: tempGroupID,
        isNewGroup: true
      });
      this.newGroupBuffer[tempGroupID] = this.newGroupName;
      this.showCreateForm = false;
      this.newGroupName = "";
      this.newGroupCounter++;
      this.groupNameUniqueError = false;
    },
    toggleEdit(group, index) {
      //   let editGroup = group);
      group.edit = true;

      this.groups.splice(index, 1, group);
      setTimeout(() => {
        this.$refs[group.groupID][0].focus();
      }, 100);
    },
    deleteGroup(group, index) {
      group.showDelete = true;
      this.groups.splice(index, 1, group);
    },
    confirmDelete(group, index) {
      if (group.isNewGroup) {
        delete this.newGroupBuffer[group.groupID];
        delete this.tempGroupChangesBuffer[group.groupID];
        delete this.groupNameChangeBuffer[group.groupID];
      } else {
        this.deleteGroupBuffer[group.groupID] = group.groupID;
      }
      this.groups.splice(index, 1);
    },
    cancelDelete(group, index) {
      group.showDelete = false;
      this.groups.splice(index, 1, group);
    },
    saveEdit(group, index) {
      this.groupNameChangeBuffer[group.groupID] = group.name;
      group.edit = false;
      this.groups.splice(index, 1, group);
    },
    closeModal() {
      this.$refs.managegroups.hide();
    },
    saveChanges() {
      let payload = {};
      payload.requiredData = {
        manageGroups: {},
        getGroupsSitesV3: 1,
        getSites: 1
      };
      if (this.newGroupBuffer) {
        payload.requiredData.manageGroups.new = {};
        payload.requiredData.manageGroups.new = this.newGroupBuffer;
      }
      if (this.tempGroupChangesBuffer) {
        _.each(this.tempGroupChangesBuffer, (tempBuffer, groupID) => {
          if (_.isEmpty(tempBuffer)) {
            tempBuffer.push("empty");
          }
        });
        payload.requiredData.manageGroups.updateSites = {};
        // if(this.tempGroupChangesBuffer)
        payload.requiredData.manageGroups.updateSites = this.tempGroupChangesBuffer;
      }
      if (this.groupNameChangeBuffer) {
        payload.requiredData.manageGroups.updateNames = {};
        payload.requiredData.manageGroups.updateNames = this.groupNameChangeBuffer;
      }
      if (this.deleteGroupBuffer) {
        payload.requiredData.manageGroups.delete = {};
        payload.requiredData.manageGroups.delete = this.deleteGroupBuffer;
      }
      this.$store.dispatch("sendAction", payload).then(response => {
        this.$store.commit("SET_GROUPS", response.data.getGroupsSitesV3);
        this.$store.commit("UPDATE_SITES", response.data.getSites);
        this.closeModal();
      });
    }
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/modals/ManageGroups.vue